import React from 'react'

const Matrix = ({ valuesRow, selectRows }) => (
  <table className="formz-matrix-table">
    <thead>{valuesRow}</thead>
    <tbody>{selectRows}</tbody>
  </table>
)

export default Matrix
